import { rootLinks } from '../app/links';

const base = `${rootLinks.inner()}/tasks`;

export const profileTasksLinks = {
  root: () => base,
  taskDetails: (id: number | ':id') => `${base}/details/${id}`,
};
